import React, { useEffect, useState, useMemo } from "react";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import TextfieldInput from "@_components/TextfieldInput/TextfieldInput";
import DateInput from "@_components/DateInput/DateInput";
import styles from "./ReminderPopup.module.css";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { caseActions } from "@_actions/case.actions";
import { casesActions } from "@_actions/cases.actions";
import { caseConstants } from "@_constants/case.constants";
import moment from "moment";

function ReminderPopup(props) {
  const dispatch = useDispatch();
  const [nameInput, setNameInput] = useState(
    props.data.reminder_name ? props.data.reminder_name : "Reminder",
  );
  const [dateInput, setDateInput] = useState(
    props.data.reminder_date ? props.data.reminder_date : "",
  );
  const requestState = useSelector(
    (state) => state.caseReducer.status.CASE_UPDATE_DEADLINE,
  );
  const { data, caseId, doClose } = props;

  // Calculate minDate for date picker (tomorrow)
  const minDate = useMemo(() => {
    return moment().add(1, "days");
  }, []);

  function handleDelete() {
    //send null,null to service
    dispatch(caseActions.updateReminder(caseId, null));
  }

  function handleConfirm() {
    //send data to service
    dispatch(
      caseActions.updateReminder(caseId, { name: nameInput, date: dateInput }),
    );
  }

  useEffect(() => {
    if (requestState && requestState === "success") {
      dispatch(casesActions.getCases());
      doClose();
      //reset requestState so that we ca open again
      dispatch({ type: caseConstants.CASE_UPDATE_DEADLINE_FAILURE_RESET });
    }
  }, [requestState, doClose, dispatch]);

  return (
    <DialogPopup
      title="Reminder Settings"
      open={props.open}
      onClose={() => props.close()}
      //size={"large"}
    >
      <div className={styles.dialog_container}>
        <div className={styles.input_name}>
          <TextfieldInput
            className={styles.input_small}
            label="Reminder Title"
            id="reminder_title"
            name="reminder_title"
            type="string"
            value={nameInput}
            onChange={(event) => setNameInput(event.target.value)}
          />
        </div>
        <div className={styles.input_date}>
          <DateInput
            label="Reminder date"
            id="reminder_date"
            name="reminder_date"
            value={dateInput}
            onChange={(date) => setDateInput(date)}
            minDate={minDate}
          />
        </div>
        <div className="action_container">
          <Button
            className="btn_cancel"
            data-testid="reminder-cancel-btn"
            onClick={() => props.close()}
          >
            Cancel
          </Button>
          <Button
            className={styles.btn_delete}
            data-testid="reminder-delete-btn"
            onClick={handleDelete}
            disabled={!data.reminder_date}
          >
            Delete
          </Button>
          <Button
            className="btn_confirm"
            data-testid="reminder-confirm-btn"
            onClick={handleConfirm}
            disabled={!dateInput || (dateInput && dateInput.length < 1)}
          >
            Confirm
          </Button>
        </div>
      </div>
    </DialogPopup>
  );
}

export default ReminderPopup;
